import { Dragging } from './Dragging';

export const DraggingModule = {
  __init__: ['dragging'],
  dragging: ['type', Dragging],
};
